import { API_URLS } from '@chessx/shared/api-routes'
import { useQuery, UseQueryResult } from '@tanstack/react-query'
import axiosInstance from './axiosInstance'
import { toastMixin } from '../utils/interact'
import type { HeroFilters } from '../types/api'

const getHeroes = async (page = 0, limit = 12, filters: HeroFilters) => {
  const url = API_URLS.ADMIN_HEROES
  const statusValue = Object.keys(filters.status)
    .filter(obj => filters.status[obj])
    .toString()
  const colorValue = Object.keys(filters.color)
    .filter(obj => filters.color[obj])
    .map(obj => obj[0])
    .toString()
  const pieceTypeValue = Object.keys(filters.pieceType)
    .filter(obj => filters.pieceType[obj])
    .toString()
  const params = {
    page,
    limit,
    sale: statusValue,
    color: colorValue,
    pieceType: pieceTypeValue
  }

  return await axiosInstance.get(url, { params })
}

export interface HeroesData {
  data?: Array<Record<string, unknown>>
  totalCount?: number
  [key: string]: unknown
}

export interface FetchHeroesResult {
  isLoading: boolean
  data: HeroesData
  isError: boolean
  error: UseQueryResult['error']
  refetch: UseQueryResult['refetch']
}

export const fetchHeroes = (
  mPage: number,
  mLimit: number,
  mFilters: HeroFilters
): FetchHeroesResult => {
  const { isLoading, data, isError, error, refetch } = useQuery({
    queryKey: ['HEROES', { mPage, mLimit, mFilters }],
    queryFn: async () => {
      const result = await getHeroes(mPage, mLimit, mFilters)
      return result.data
    },
    gcTime: 0
  })

  if (isError) {
    toastMixin.fire({ title: `Error fetching Heroes: ${error}`, icon: 'error' })
  }

  return { isLoading, data: (data as HeroesData) || {}, isError, error, refetch }
}
